import { SET_ACCOUNT } from './AccountTypes';

export const setAccount = account => ({
  type: SET_ACCOUNT,
  payload: account
});
